import React from "react";

const I = ({ children, className, ...p }) => (
  <svg
    className={`fx-ico${className ? ` ${className}` : ""}`}
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    {...p}
  >
    {children}
  </svg>
);

export const IconUser = (p) => (
  <I {...p}><circle cx="12" cy="8" r="3.6" /><path d="M4.5 20c1.4-4 4.2-6 7.5-6s6.1 2 7.5 6" /></I>
);
export const IconMail = (p) => (
  <I {...p}><rect x="3.5" y="5" width="17" height="14" rx="2" /><path d="M4 7l8 6 8-6" /></I>
);
export const IconPhone = (p) => (
  <I {...p}><path d="M6 3h4l2 5-2.5 1.5a11 11 0 0 0 5 5L16 12l5 2v4a2 2 0 0 1-2 2C11 20 4 13 4 5a2 2 0 0 1 2-2Z" /></I>
);
export const IconPin = (p) => (
  <I {...p}><path d="M12 21s7-6.2 7-12a7 7 0 1 0-14 0c0 5.8 7 12 7 12Z" /><circle cx="12" cy="9" r="2.4" /></I>
);
export const IconLock = (p) => (
  <I {...p}><rect x="5" y="10" width="14" height="10" rx="2" /><path d="M8 10V7a4 4 0 0 1 8 0v3" /></I>
);
export const IconVerify = (p) => (
  <I {...p}><path d="M9 12l2 2 4-4" /><circle cx="12" cy="12" r="9" /></I>
);
export const IconCheck = (p) => (
  <I {...p}><path d="M4 12l5 5L20 6" /></I>
);
export const IconClock = (p) => (
  <I {...p}><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></I>
);
export const IconX = (p) => (
  <I {...p}><path d="M6 6l12 12M18 6L6 18" /></I>
);
export const IconMinus = (p) => (
  <I {...p}><path d="M6 12h12" /></I>
);
export const IconUpload = (p) => (
  <I {...p}><path d="M12 16V5M7 10l5-5 5 5M5 19h14" /></I>
);
export const IconFile = (p) => (
  <I {...p}><path d="M7 3h7l4 4v14H7z" /><path d="M14 3v4h4" /></I>
);
export const IconAlert = (p) => (
  <I {...p}><circle cx="12" cy="12" r="9" /><path d="M12 7.5v5M12 16v.01" /></I>
);
export const IconDoc = (p) => (
  <I {...p}><rect x="3.5" y="5" width="17" height="14" rx="2" /><circle cx="9" cy="11" r="2" /><path d="M14 10h4M14 14h4M6.5 16c.6-1.4 1.4-2 2.5-2s1.9.6 2.5 2" /></I>
);

/* ---------- иконки навигации (шапка и боковые панели) ---------- */
export const IconDownload = (p) => (
  <I {...p}><path d="M12 4v12M6 12l6 6 6-6M5 20h14" /></I>
);
export const IconMenu = (p) => (
  <I {...p}><path d="M4 7h16M4 12h16M4 17h16" /></I>
);
export const IconChevronDown = (p) => (
  <I {...p}><path d="M6 9l6 6 6-6" /></I>
);
export const IconChevronRight = (p) => (
  <I {...p}><path d="M9 6l6 6-6 6" /></I>
);
export const IconCopy = (p) => (
  <I {...p}><rect x="8.5" y="8.5" width="11" height="11" rx="2" /><path d="M15.5 8.5V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v7.5a2 2 0 0 0 2 2h2.5" /></I>
);
export const IconLogout = (p) => (
  <I {...p}><path d="M9 4H5v16h4M16 8l4 4-4 4M20 12H9" /></I>
);
export const IconWallet = (p) => (
  <I {...p}><rect x="3.5" y="6" width="17" height="13" rx="2" /><path d="M3.5 10h17M16 14.5h.01" /></I>
);
export const IconChart = (p) => (
  <I {...p}><path d="M4 19V5M4 19h16M8 15l3-4 3 2 4-6" /></I>
);
export const IconList = (p) => (
  <I {...p}><path d="M9 6h11M9 12h11M9 18h11M4.5 6h.01M4.5 12h.01M4.5 18h.01" /></I>
);
export const IconCoin = (p) => (
  <I {...p}><circle cx="12" cy="12" r="9" /><path d="M10 7.5v9M10 7.5h3.2a2.2 2.2 0 0 1 0 4.5H10h3.6a2.25 2.25 0 0 1 0 4.5H10M11.5 6v1.5M11.5 16.5V18" /></I>
);
export const IconCard = (p) => (
  <I {...p}><rect x="3" y="6" width="18" height="12" rx="2" /><path d="M3 10.5h18M7 15h3" /></I>
);
export const IconGlobe = (p) => (
  <I {...p}><circle cx="12" cy="12" r="9" /><path d="M3 12h18M12 3c3 3 3 15 0 18M12 3c-3 3-3 15 0 18" /></I>
);

/* стандартный значок профиля (залитый силуэт) */
export const IconAvatar = (p) => (
  <I {...p} style={{ fill: "currentColor", stroke: "none" }}>
    <circle cx="12" cy="8.5" r="4" />
    <path d="M4 21c0-4.4 3.6-7 8-7s8 2.6 8 7z" />
  </I>
);
